<section class="hero">


  <div class="hero-content">

    <h1 class="hero-title">
      <span class="line-one">
        Build <span class="blue">Software</span>
      </span>

      <span class="line-two">
        That Actually Scales
      </span>
      
    </h1>

    <!-- <p class="hero-sub logo-small">
      Enterprise SaaS, Custom Software, Mobile Apps, and White-Label Solutions Built to Streamline Operations and Scale Your Business.
    </p>

    <div class="hero-features logo-small">
      <span class="blue"><i class="fas fa-globe"></i> Global Delivery</span>
      <span class="blue"><i class="fas fa-shield"></i> Secure Architecture</span>
      <span class="blue"><i class="fas fa-arrow-trend-up"></i> Scalable Solutions</span>
    </div>

    <p class="hero-sub logo-small">
      We design and build enterprise-grade software  products for Startups, SMEs, and Global brands.
    </p> -->

    <div class="hero-buttons">
      <a (click)="$event.preventDefault(); scrollTo('contact')" href="#contact" class="btn primary">Start Project</a>
      <a (click)="$event.preventDefault(); scrollTo('work')" href="#work" class="btn secondary">View Work</a>
    </div>

    

  </div>

  <!-- <div class="trust-strip">
    <p>Trusted by startups • agencies • global brands</p>

    <div class="marquee-wrapper">
      <div class="marquee-track">
        10 logos
        <img src="assets/trusted_company_logos/Google__G__logo.svg" alt="Google_logo">
        <img src="assets/trusted_company_logos/Adobe_Systems_logo_and_wordmark.svg" alt="Adobe_logo">
        <img src="assets/trusted_company_logos/Spotify_icon.svg" alt="Spotify_icon">
        <img src="assets/trusted_company_logos/stripe.svg" alt="stripe">
        <img src="assets/trusted_company_logos/shopify.svg" alt="shopify">
        <img src="assets/trusted_company_logos/Airbnb_Logo.svg" alt="Airbnb_logo">
        <img src="assets/trusted_company_logos/Slack_icon_2019.svg" alt="Slack_icon">
        <img src="assets/trusted_company_logos/Microsoft_logo.svg" alt="Microsoft_logo">
        <img src="assets/trusted_company_logos/notion.svg" alt="notion">
        <img src="assets/trusted_company_logos/Netflix_2015_logo.svg" alt="Netflix_logo">
        
        Duplicated 10 logos for smooth looping
        <img src="assets/trusted_company_logos/Google__G__logo.svg" alt="Google_logo">
        <img src="assets/trusted_company_logos/Adobe_Systems_logo_and_wordmark.svg" alt="Adobe_logo">
        <img src="assets/trusted_company_logos/Spotify_icon.svg" alt="Spotify_icon">
        <img src="assets/trusted_company_logos/stripe.svg" alt="stripe">
        <img src="assets/trusted_company_logos/shopify.svg" alt="shopify">
        <img src="assets/trusted_company_logos/Airbnb_Logo.svg" alt="Airbnb_logo">
        <img src="assets/trusted_company_logos/Slack_icon_2019.svg" alt="Slack_icon">
        <img src="assets/trusted_company_logos/Microsoft_logo.svg" alt="Microsoft_logo">
        <img src="assets/trusted_company_logos/notion.svg" alt="notion">
        <img src="assets/trusted_company_logos/Netflix_2015_logo.svg" alt="Netflix_logo">
      </div>
    </div>
  </div> -->

</section>